import React, {useEffect, useState} from "react";
import {useNavigate, useParams} from "react-router-dom";
import question from "@/assets/images/question.svg";
import {getFaq} from "@/api/faq";
import {useLoadingStore} from "@/stores/loading";
import * as Common from "@/utils/common";
import {Faq} from "@/types/faq";
import {useFaqSearch} from "@/stores/faqSearch";
import {useFaqFont} from "@/utils/useFaqFont";
import {CustomMarkdown} from "@/components/CustomMarkdown";

export default function FaqDetail() {
  const navigate = useNavigate();
  useFaqFont();
  const setLoading = useLoadingStore(state => state.setLoading);
  const {setOrder, backPage} = useFaqSearch();
  const faqId = Number(useParams().id);
  const [faq, setFaq] = useState<Faq>()

  const onClickBack = () => {
    setOrder("1")
    navigate(backPage);
  };

  useEffect(() => {
    setLoading(true)
    getFaq(faqId).then(result => {
      setFaq(result.data)
    }).catch(error => {
    }).finally(() => {
      setLoading(false)
    })
  }, [])

  return (
    <div className="uk-flex uk-flex-column uk-flex-middle">
      <div className="sub-header">
        <p className="uk-text-large uk-text-bold uk-margin-remove">
          よくある質問
        </p>
      </div>
      <div className="uk-width-3-4 uk-margin-top">
        <div className="uk-flex uk-flex-middle">
          <img src={question} alt=""/>
          <p className="uk-text-medium uk-text-bold uk-margin-small-left">
            よくある質問（FAQ）
          </p>
        </div>
        <div className="padding-20 uk-flex background-gray243 uk-margin-top">
          <p className="uk-text-medium-l uk-text-bold uk-margin-small-right">
            Q.
          </p>
          <div>
            <p className="uk-text-large-l uk-text-bold">{faq?.title}</p>
            <p className="uk-text-medium-s uk-margin-small-top">
              <CustomMarkdown content={faq?.question}/>
            </p>
          </div>
        </div>
        <div className="uk-flex uk-margin-top uk-margin-left">
          <p className="uk-text-medium-l uk-text-bold uk-margin-small-right">
            A.
          </p>
          <div>
            <p className="uk-text-medium-s">
              <CustomMarkdown content={faq?.answer}/>
            </p>
            <div className="uk-flex uk-flex-between uk-margin-top">
              <div className="uk-flex">
                <div className="uk-flex uk-flex-middle width-175">
                  <p className="tag-dark">管理番号</p>
                  <p className="uk-text-default margin-left-16">{Common.controlNum(faqId)}</p>
                </div>
                <div className="uk-flex uk-flex-middle width-175">
                  <p className="tag-dark">更新日</p>
                  <p className="uk-text-default margin-left-27">{faq?.modified}</p>
                </div>
              </div>
              <div className="uk-flex uk-flex-wrap gap-10 uk-margin-small-right">
                {faq?.faq_type.map((type, i) => (
                  <p key={i} className="tag-light">{type.name}</p>
                ))}
                {faq?.faq_kind.map((kind, i) => (
                  <p key={i} className="tag-light">{kind.name}</p>
                ))}
              </div>
            </div>
          </div>
        </div>
        <div className="uk-flex uk-flex-center uk-margin-large">
          <button className="button-dark" onClick={onClickBack}>
            一覧へ戻る
          </button>
        </div>
      </div>
    </div>
  );
}

